module.exports = __webpack_public_path__ + "static/media/bg_0.8579f41d.jpg";